import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../config/design/TableIcons";
import {Link, withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import {TableCount, TablePage} from "../../../../config/Permissions";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import AppCardLoaderTable from "../../../components/Skeletons/AppCardLoaderTable";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {currencySymbol} from "../../../../config/values";
import CurrencyFormat from "react-currency-format";
import Button from "@material-ui/core/Button/Button";
import {hasProductLimit, UserHasLimit} from "../../../../config/Security";
import AddBox from "@material-ui/icons/AddBox";
import IconButton from "@material-ui/core/IconButton/IconButton";
import PublishRoundedIcon from '@material-ui/icons/PublishRounded';
class Wallets extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            {
                field: 'user',
                editable: 'never',
                filtering: false,
                title: Translate.userName,
            },
            {
                field: 'active',
                editable: 'never',
                filtering: false,
                title: Translate.activeStatus,
                lookup: {
                    1 :
                        <Typography style={{color: "#38bf84"}}>{Translate.active}</Typography>
                    ,
                    0:
                        <Typography style={{color:"#BF8230"}}>{Translate.inactive}</Typography>
                },
            },
            { title: Translate.walletInventory,
                field: 'amount',
                filterPlaceholder: Translate.search,
                render: rowData => <CurrencyFormat value={rowData.amount} displayType={'text'} thousandSeparator={true}  suffix={" "+currencySymbol} />
            },

        ],
        data: [],
        loading:false,
        ChangeLoader:false
    };
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    handleRowClick(data){
        this.props.history.push(`/manage/wallet/${data.id}`);
    }
    render(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl">
                            <MaterialTable
                                parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                                tableRef={this.tableRef}
                                icons={tableIcons}
                                onRowClick={((evt, selectedRow) =>  this.handleRowClick(selectedRow))}

                                title={
                                    <>
                                        {
                                            this.props.width !== "xs" ?
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    component='a'
                                                    target="_blank"
                                                    startIcon={<PublishRoundedIcon/>}
                                                    href={`${defaultVariabls.website}/export-payments`}
                                                >
                                                    {Translate.exportPaymentRequest}
                                                </Button> :
                                                <IconButton color="primary"
                                                            component='a'
                                                            target="_blank"
                                                            href={`${defaultVariabls.website}/export-payments`}
                                                >
                                                    <PublishRoundedIcon/>
                                                </IconButton>
                                        }
                                    </>
                                }
                                localization={DataTableLocalization}
                                columns={this.state.columns}
                                data={query =>
                                    new Promise((resolve, reject) => {
                                        axios.get(`${defaultVariabls.url}/wallet/getAllUsersWalletHasRequest?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, config)
                                            .then(response => {
                                                let data = [];
                                                // eslint-disable-next-line
                                                response.data.data.map((row) => {
                                                    data.push({
                                                        amount: row.amount,
                                                        id: row.id,
                                                        user: row.user.first_name+" "+row.user.last_name,
                                                        active: row.active,
                                                        created_at: row.created_at,
                                                    })
                                                });
                                                resolve({
                                                    data: data,
                                                    page: response.data.current_page - 1,
                                                    totalCount: response.data.total,
                                                })
                                            }).catch(error => {
                                            console.log(error)
                                        })
                                    })
                                }
                                options={{
                                    pageSize: TablePage,
                                    pageSizeOptions: TableCount,
                                    defaultExpanded:true,
                                }}
                            />
                        </Container>
                }
            </>

        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Wallets)))));